import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.705 2.413a.666.666 0 0 0-.52-1.08h-12a.667.667 0 0 0-.52 1.08l5.854 7.32v3.6H3.685a.667.667 0 1 0 0 1.334h9a.666.666 0 1 0 0-1.334H8.852v-3.6zm-11.133.254h9.227l-1.6 2h-6zm4.613 5.766L6.24 6h3.893z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })